import React from "react"
import styled from "styled-components"

import TiktokIcon from "src/assets/svg/icon-tiktok.svg"
import FacebookIcon from "src/assets/svg/icon-facebook.svg"
import InstagramIcon from "src/assets/svg/icon-instagram.svg"
import XIcon from "src/assets/svg/icon-x.svg"

const SocialIcons = () => {
  return (
    <StyledSocialIcons>
      <a
        href="https://www.tiktok.com/@fubosports"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="TikTok"
      >
        <TiktokIcon />
      </a>
      <a
        href="https://www.facebook.com/fubosports"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Facebook"
      >
        <FacebookIcon />
      </a>
      <a
        href="https://www.x.com/fubosports"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="X"
      >
        <XIcon />
      </a>
      <a
        href="https://www.instagram.com/fubosports"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Instagram"
      >
        <InstagramIcon />
      </a>
    </StyledSocialIcons>
  )
}

export default SocialIcons

const StyledSocialIcons = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 60px 30px;
  background: #000;

  @media (max-width: 768px) {
    gap: 10px;
    padding: 40px 20px;
  }

  a {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: transform 0.2s ease;
    padding: 18px;

    @media (max-width: 768px) {
      width: 60px;
      height: 60px;
      padding: 14px;
    }

    &:hover {
      transform: scale(1.1);
    }

    svg {
      width: 100%;
      height: 100%;
      fill: #fff;
      opacity: 0.7;
    }
  }
`
